import React, { useContext } from 'react';
// Components
import { Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import IndividualProgressIndicator from '../../../create-new-common/IndividualProgressIndicator';

// Context
import { SequencingWizardContext } from '../SequencingWizardContext';

const ListItem = styled('div')(({ theme }) => ({
  alignItems: 'center',
  backgroundColor: theme.palette.graphic.lighter,
  borderBottom: `1px solid rgba(0, 0, 0, 0.08)`,
  display: 'flex',
  justifyContent: 'space-between',
  padding: theme.spacing(2, 3),
}));

const NotSequencedDiv = styled('div')(({ theme }) => ({
  alignItems: 'center',
  backgroundColor: theme.palette.graphic.lighter,
  padding: theme.spacing(2, 3),
}));

const SequencingProgressItem = () => {
  const {
    data: { changeList },
  } = useContext(SequencingWizardContext);
  return changeList.length ? (
    changeList.map(
      ({ location, product, locationNameShort, productNameShort, message, success }, index) => {
        const key = `${location?.nameShort || locationNameShort}-${
          product?.nameShort || productNameShort
        }-${index}`;
        return (
          <ListItem key={key}>
            <Typography color="textPrimary" variant="body1">
              {product?.nameShort || productNameShort} at {location?.nameShort || locationNameShort}
            </Typography>
            <IndividualProgressIndicator error={message ?? ''} isSuccessful={success ?? false} />
          </ListItem>
        );
      }
    )
  ) : (
    <NotSequencedDiv>
      <Typography color="textPrimary" variant="body1">
        The selected Inventory Owners are not currently sequenced for the selected products and
        locations. No changes made.
      </Typography>
    </NotSequencedDiv>
  );
};

export default SequencingProgressItem;
